import { serviceApi } from '~/api/service';

export const appointmentTypeUrl = (id) => `appointment-types/${id}/products`;

export const productsApi = {
  fetch: (id, options = {}, serviceId = undefined, byPassErrorCodes = []) =>
    serviceApi.fetchJSON(appointmentTypeUrl(id), options, serviceId, byPassErrorCodes),
};
